function trackDyCustomEvent ({ name, props }) {

	const eventPayload = {
		name
	};

	if (typeof props === 'object') {

		eventPayload.properties = props;

	}

	window.top.DY?.API?.('event', eventPayload);

}

export default trackDyCustomEvent;
